<template>
    <div class="modal is-active modal-site-inicio">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <div class="modal-card-title has-text-centered">Torne o URLinks a sua página inicial. Siga as instruções abaixo: </div>
            </header>

            <section class="modal-card-body" >

                <div v-if="browser=='Chrome'">
                    <img src="images/start_page_chrome_3.png">
                    <p>Pronto. Você já pode fechar a aba definições. Ao iniciar o seu navegador, o URLinks será a sua página inicial. Bom proveito!</p>
                </div>
                <div v-if="browser=='Edge'">
                    <img src="images/start_page_edge_3.png">
                    <p>Pronto. Você já pode fechar a aba definições. Ao iniciar o seu navegador, o URLinks será a sua página inicial. Bom proveito!</p>
                </div>
                <div v-if="browser=='IE'">
                    <img src="images/start_page_ie_3.png">
                    <p>Pronto. Você já pode fechar a aba definições. Ao iniciar o seu navegador, o URLinks será a sua página inicial. Bom proveito!</p>
                </div>
                <div v-if="browser=='Firefox'">
                    <img src="images/start_page_firefox_3.png">
                    <p>Pronto. Você já pode fechar a aba definições. Ao iniciar o seu navegador, o URLinks será a sua página inicial. Bom proveito!</p>
                </div>
                <div v-if="browser=='Safari'">
                    <img src="images/start_page_safari_3.png">
                    <p>Pronto. Você já pode fechar a aba definições. Ao iniciar o seu navegador, o URLinks será a sua página inicial. Bom proveito!</p>
                </div>
                <div v-if="browser=='Android'">
                    Android...
                </div>
                <div v-if="browser=='iPhone'">
                    iPhone...
                </div>
                <div v-if="browser=='other'">
                    Outros
                </div>

            </section>
            <footer class="modal-card-foot">
                <label class="checkbox"><input type="checkbox" v-model="skipSiteInicio"> Não exibir esta mensagem novamente</label>
                <button class="button" @click.prevent="goBack">Fechar</button>
            </footer>

            <div class="modal-card-body" v-if="isloading">Carregando</div>
        </div>
    </div>
</template>


<script>

import firebase from '@/firebase'
export default {
    data() {
        return {
            skipSiteInicio:false,
            browser:'',
            db: null,
            isloading:false,
        }
    },
    computed: {
        userId() {
            return this.$store.getters.userId;
        },
    },
    methods:{
        goBack(){
            if(this.skipSiteInicio){
                this.db = firebase.firestore();
                this.db.collection('users').doc(this.userId).update({ skipSiteInicio:this.skipSiteInicio });
            }
            this.$router.push({name:'home'});
        },
        checkBrowser(){
            if(window.navigator.userAgent.match(/Edge/i)) return 'Edge';
            if(window.navigator.userAgent.match(/MSIE|trident/i)) return 'IE';
            if(window.navigator.userAgent.match(/Firefox/i)) return 'Firefox';
            if(window.navigator.userAgent.match(/Chrome/i)) return 'Chrome';
            if(window.navigator.userAgent.match(/Safari/i)) return 'Safari';
            if(window.navigator.userAgent.match(/Android/i)) return 'Android';
            if(window.navigator.userAgent.match(/iPhone|iPad/i)) return 'iPhone';
            return 'other';
        }
    },
    mounted() {
        this.browser = this.checkBrowser();
    },
    beforeDestroy() {
    },
};
</script>


<style>
    .modal-site-inicio img { margin-bottom:20px; }
    .modal-site-inicio p {text-align: center; margin-bottom:20px; }
    @media screen and (min-width: 991px){
        .modal-site-inicio .modal-card { width:960px; }
    }
    .modal-site-inicio .modal-card-foot {
        justify-content: space-between;
     }
    .modal-site-inicio .modal-card-foot label {
        font-weight: bold;
        color:#00b3bc;
    }
    .modal-site-inicio .modal-card-foot label:hover {
        color:#00b3bc;

    }
</style>
